/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLoopLeft = createReactComponent("arrow-loop-left", "IconArrowLoopLeft", [
  ["path", { d: "M13 21v-13a4 4 0 1 1 4 4h-13", key: "svg-0" }],
  ["path", { d: "M8 16l-4 -4l4 -4", key: "svg-1" }]
]);

export { IconArrowLoopLeft as default };
//# sourceMappingURL=IconArrowLoopLeft.js.map
